import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
import { type ReactNode } from 'react';

import { FormSectionLabel } from './components/FormSectionLabel';
import { SIDEBAR_WIDTH_PX } from '../constants';
import { SemicontrolledInput } from '../SemicontrolledInput';

interface Props {
  children?: ReactNode;
  sideBarTitle?: string;
  comment?: string;
  handleSetComment?: (comment: string) => void;
  handleCloseSidebar: () => void;
  showComments?: boolean;
}

export const SidebarWrap = ({
  children,
  sideBarTitle = 'Properties',
  comment,
  handleSetComment = () => {},
  handleCloseSidebar,
  showComments = true,
}: Props) => {
  return (
    <Stack position="relative" width={`${SIDEBAR_WIDTH_PX}px`}>
      <Box
        position="absolute"
        top={0}
        right={0}
        bgcolor="white"
        width="100%"
        height="100%"
        overflow="auto"
      >
        <Stack
          direction="row"
          px={2}
          py={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h3">{sideBarTitle}</Typography>
          <IconButton
            aria-label="Close sidebar"
            size="small"
            onClick={handleCloseSidebar}
          >
            <CloseIcon />
          </IconButton>
        </Stack>

        <Divider />

        <Stack p={2} gap={2}>
          {/* task fields or labware fields */}
          {children}

          {showComments ? (
            <>
              <FormSectionLabel>Comments</FormSectionLabel>
              <SemicontrolledInput
                TextFieldProps={{
                  placeholder: 'Click to write comment',
                  multiline: true,
                  rows: 4,
                  fullWidth: true,
                }}
                value={comment ?? ''}
                handleSaveValue={handleSetComment}
              />
            </>
          ) : null}
        </Stack>
      </Box>
    </Stack>
  );
};
